import React, { Component } from 'react'
import { Icon } from '@driftt/tide-core-legacy'

import './style.styl'

const OnboardingHeader = ({ onHideForever, onHide }) => (
  <div className="prioritize-playbooks-onboarding">
    <header>
      <h4>How Playbook Prioritization Works</h4>
      <div className="prioritize-playbooks-onboarding-dismiss">
        <span onClick={onHide}>Dismiss</span>
        <div>
          <span onClick={onHide}>For now?</span>
          <span onClick={onHideForever}>Forever?</span>
        </div>
      </div>
    </header>
    <div className="prioritize-playbooks-onboarding-steps">
      <div className="prioritize-playbooks-onboarding-step">
        <div className="prioritize-playbooks-onboarding--content">
          <Icon name={'list-numbers'} width={28} height={28} />
          <h3>Order your playbooks from most important to least important.</h3>
          <p>Let Drift know which messages matter the most to you by placing them at the top.</p>
        </div>
      </div>
      <div className="prioritize-playbooks-onboarding-step">
        <div className="prioritize-playbooks-onboarding--content">
          <Icon name={'message-1-heart'} width={28} height={28} />
          <h3>Drift will send the most relevant message.</h3>
          <p>Drift checks which playbooks match your visitor and sends the most important one.</p>
        </div>
      </div>
      <div className="prioritize-playbooks-onboarding-step">
        <div className="prioritize-playbooks-onboarding--content">
          ​<iframe src="https://www.youtube.com/embed/ECrmWZ-Jz1c" frameBorder="0" allow="encrypted-media" allowFullScreen></iframe>
        </div>
      </div>
    </div>
  </div>
)

export default ({ show, ...props }) => show ? <OnboardingHeader {...props} /> : null



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/Prioritize/OnboardingHeader.js